import { Button, Grid2, Popover, Stack, useTheme } from '@mui/material';
import { AddRounded, CheckRounded } from '@mui/icons-material';

interface ColorPickerProps {
  colors: string[];
  currentColor: string;
  onChange: (color: string) => void;
  onCustomColor?: () => void;
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  topOffset?: number;
}

export default function ColorPicker({
  currentColor,
  colors,
  onChange,
  onCustomColor,
  open,
  onClose,
  anchorEl,
  topOffset = 0,
}: ColorPickerProps) {
  const theme = useTheme();

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      slotProps={{
        paper: {
          sx: {
            marginTop: topOffset ? `${topOffset}px` : undefined,
          },
        },
      }}>
      <Grid2 container spacing={1} columns={6} p={1.5}>
        {colors.map(color => (
          <Grid2 key={color} size={1}>
            <Stack
              position="relative"
              component={Button}
              width="100%"
              sx={{
                aspectRatio: 1,
                minWidth: 'auto',
                p: 0,
                ':hover': {
                  filter: 'brightness(0.9)',
                },
              }}
              borderRadius="100%"
              bgcolor={color}
              onClick={() => onChange(color)}>
              {currentColor === color && (
                <Stack
                  position="absolute"
                  alignItems="center"
                  justifyContent="center"
                  top={0}
                  left={0}
                  bottom={0}
                  right={0}
                  width="100%"
                  height="100%"
                  bgcolor={color}
                  color={theme.palette.background.default}
                  borderRadius="100%">
                  <CheckRounded sx={{ fontSize: '16px' }} />
                </Stack>
              )}
            </Stack>
          </Grid2>
        ))}
        {!!onCustomColor && (
          <Grid2 size={1}>
            <Button
              variant="text"
              onClick={onCustomColor}
              sx={{
                width: '100%',
                aspectRatio: 1,
                p: 0,
                minWidth: 'auto',
                borderRadius: '100%',
                color: theme.palette.darkGrey.main,
                bgcolor: theme.palette.darkerLightGrey.main,
              }}>
              <AddRounded sx={{ fontSize: '16px' }} />
            </Button>
          </Grid2>
        )}
      </Grid2>
    </Popover>
  );
}
